export default [
  {
    path: '/auth/sso',
    component: () =>
      import(/* webpackChunkName: 'Auth' */ '../../views/SsoCallback'),
    meta: {
      title: 'Authentication'
    }
  },
  {
    path: '/auth/sso-error',
    component: () =>
      import(/* webpackChunkName: 'Auth' */ '../../views/SsoError'),
    meta: {
      title: 'Authentication'
    }
  }
]
